// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * cdr-shared-api
 * Shared API Gateway for all CDR endpoints
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GrantItem
 */
export interface GrantItem {
    /**
     * 
     * @type {Array<string>}
     * @memberof GrantItem
     */
    capabilities: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof GrantItem
     */
    capability_set: string;
    /**
     * 
     * @type {string}
     * @memberof GrantItem
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof GrantItem
     */
    granted_at: string;
    /**
     * 
     * @type {string}
     * @memberof GrantItem
     */
    granted_by: string;
    /**
     * 
     * @type {string}
     * @memberof GrantItem
     */
    principal_id: string;
    /**
     * 
     * @type {string}
     * @memberof GrantItem
     */
    status: GrantItemStatusEnum;
}


/**
 * @export
 */
export const GrantItemStatusEnum = {
    Active: 'active',
    Pending: 'pending'
} as const;
export type GrantItemStatusEnum = typeof GrantItemStatusEnum[keyof typeof GrantItemStatusEnum];


/**
 * Check if a given object implements the GrantItem interface.
 */
export function instanceOfGrantItem(value: object): value is GrantItem {
    if (!('capabilities' in value) || value['capabilities'] === undefined) return false;
    if (!('capability_set' in value) || value['capability_set'] === undefined) return false;
    if (!('email' in value) || value['email'] === undefined) return false;
    if (!('granted_at' in value) || value['granted_at'] === undefined) return false;
    if (!('granted_by' in value) || value['granted_by'] === undefined) return false;
    if (!('principal_id' in value) || value['principal_id'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    return true;
}

export function GrantItemFromJSON(json: any): GrantItem {
    return GrantItemFromJSONTyped(json, false);
}

export function GrantItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): GrantItem {
    if (json == null) {
        return json;
    }
    return {
        
        'capabilities': json['capabilities'],
        'capability_set': json['capability_set'],
        'email': json['email'],
        'granted_at': json['granted_at'],
        'granted_by': json['granted_by'],
        'principal_id': json['principal_id'],
        'status': json['status'],
    };
}

export function GrantItemToJSON(json: any): GrantItem {
    return GrantItemToJSONTyped(json, false);
}

export function GrantItemToJSONTyped(value?: GrantItem | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'capabilities': value['capabilities'],
        'capability_set': value['capability_set'],
        'email': value['email'],
        'granted_at': value['granted_at'],
        'granted_by': value['granted_by'],
        'principal_id': value['principal_id'],
        'status': value['status'],
    };
}
